/**
 * @generated SignedSource<<07209c0038142e9746a582e152085cfe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkspaceComplianceRoutinesCreateButtonMutation$variables = {
  workspaceId: string;
};
export type WorkspaceComplianceRoutinesCreateButtonMutation$data = {
  readonly workspace: {
    readonly createRoutine: {
      readonly id: string;
    } | null;
  };
};
export type WorkspaceComplianceRoutinesCreateButtonMutation = {
  response: WorkspaceComplianceRoutinesCreateButtonMutation$data;
  variables: WorkspaceComplianceRoutinesCreateButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "workspaceId"
      }
    ],
    "concreteType": "WorkspaceMutation",
    "kind": "LinkedField",
    "name": "workspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "createRoutine",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceComplianceRoutinesCreateButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceComplianceRoutinesCreateButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "268f3188471478f7af03efdc565f9069",
    "id": null,
    "metadata": {},
    "name": "WorkspaceComplianceRoutinesCreateButtonMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceComplianceRoutinesCreateButtonMutation(\n  $workspaceId: ID!\n) {\n  workspace(id: $workspaceId) {\n    createRoutine {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f8ce6817534b09f907ed5d23ca3b0eb2";

export default node;
